import React from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
import { ShieldCheck, Zap } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function FinalCTASection() {
  return <section id="cta-section" className="py-20 md:py-32 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto text-center" data-id="element-29">
      <FadeIn data-id="element-30">
        <h2 className="text-4xl md:text-5xl font-bold text-dark-brown mb-6" data-id="element-31">
          RECUPERA EL CONTROL DE TU CUERPO HOY MISMO
        </h2>
        <p className="text-xl md:text-2xl text-dark-brown/80 mb-12 font-serif italic" data-id="element-32">
          Deja de pelear con el espejo y empieza a sanar desde adentro con sabor
          latino.
        </p>

        <div className="bg-white p-8 md:p-12 rounded-3xl shadow-xl border-2 border-terracotta/20 relative overflow-hidden" data-id="element-33">
          {/* Decorative corner */}
          <div className="absolute -top-12 -right-12 w-32 h-32 bg-terracotta/10 rounded-full blur-2xl" data-id="element-34"></div>

          <div className="mb-2 text-sm font-bold tracking-widest text-cinnamon uppercase" data-id="element-35">
            PRECIO ESPECIAL DE LANZAMIENTO
          </div>
          <div className="flex items-center justify-center space-x-4 mb-8" data-id="element-36">
            <span className="text-3xl text-dark-brown/40 line-through font-bold" data-id="element-37">
              $19
            </span>
            <span className="text-6xl md:text-7xl font-bold text-terracotta" data-id="element-38">
              $6.36
            </span>
          </div>

          <Button onClick={() => {
          trackAddToCart();
          window.open('https://www.cuerpodespierto.com/cart/52015650079031:1', '_blank');
        }} className="w-full md:w-auto md:px-12 py-5 text-xl mb-6" data-id="element-39">
            QUIERO MI PLAN DETOX AHORA
          </Button>

          <div className="flex flex-col sm:flex-row items-center justify-center space-y-3 sm:space-y-0 sm:space-x-8 text-dark-brown/70 font-medium" data-id="element-40">
            <div className="flex items-center" data-id="element-41">
              <ShieldCheck className="w-5 h-5 text-green-600 mr-2" data-id="element-42" />
              Pago 100% seguro
            </div>
            <div className="flex items-center" data-id="element-43">
              <Zap className="w-5 h-5 text-terracotta mr-2" data-id="element-44" />
              Acceso instantáneo (PDF)
            </div>
          </div>
        </div>
      </FadeIn>
    </section>;
}